module.exports = __webpack_public_path__ + "static/media/big-audart.2a6d9c33.jpg";